export const attributes$K = {
  id: 'data-section-id',
  type: 'data-section-type',
};

export const attributes$E = {
  swatch: 'data-swatch',
  handle: 'data-swatch-handle',
  label: 'data-swatch-label',
  image: 'data-swatch-image',
  imageId: 'data-swatch-image-id',
  variant: 'data-swatch-variant',
  variantId: 'data-variant-id',
  variantSecondaryId: 'data-variant-secondary-id',
  loaded: 'data-loaded',
  href: 'href',
};

export const attributes$w = {
  ariaCurrent: 'aria-current',
  ariaExpanded: 'aria-expanded',
  dataValue: 'data-value',
  popoutPrevent: 'data-popout-prevent',
  popoutQuantity: 'data-quantity-field',
  quickViewItem: 'data-quick-view-item',
};

export const attributes$v = {
  id: 'id',
  mediaId: 'data-media-id',
  sectionId: 'data-section-id',
  handle: 'data-handle',
  loaded: 'loaded',
  tabindex: 'tabindex',
  quickViewOnboarding: 'data-quick-view-onboarding',
  hotspot: 'data-hotspot',
  hotspotRef: 'data-hotspot-ref',
};

export const attributes$u = {
  dataOptionClasses: 'data-pswp-option-classes',
  dataVideoType: 'data-video-type',
};

export const attributes$s = {
  shippingMessageLimit: 'data-limit',
  cartMessageValue: 'data-cart-message',
  cartTotal: 'data-cart-total',
  ariaExpanded: 'aria-expanded',
  disabled: 'disabled',
  value: 'value',
  dataId: 'data-id',
  item: 'data-item',
  itemIndex: 'data-item-index',
  itemTitle: 'data-item-title',
  atcTrigger: 'data-atc-trigger',
  upsellButton: 'data-upsell-btn',
  notificationPopup: 'data-notification-popup',
  sectionId: 'data-section-id',
  recipientError: 'data-recipient-errors',
};

export const attributes$r = {
  popdownInHeader: 'data-popdown-in-header',
  popdownInPage: 'data-popdown-in-page',
  searchPerformed: 'data-search-performed',
};

export const attributes$q = {
  dataFormId: 'data-form-id',
};

export const attributes$p = {
  speed: 'data-marquee-speed',
};

export const attributes$o = {
  slide: 'data-slide',
  speed: 'data-slider-speed',
  arrows: 'data-slider-arrows',
  stop: 'data-stop',
  style: 'style',
  targetReferrer: 'data-target-referrer',
  clipPath: 'clip-path',
};

export const attributes$n = {
  disclosureToggle: 'data-hover-disclosure-toggle',
  ariaHasPopup: 'aria-haspopup',
  ariaExpanded: 'aria-expanded',
  ariaControls: 'aria-controls',
};

export const attributes$m = {
  navAlignment: 'data-nav-alignment',
  headerSticky: 'data-header-sticky',
};

export const attributes$l = {
  videoPlayValue: 'data-video-play',
};

export const attributes$k = {
  scrollSpy: 'data-scroll-spy',
  scrollSpyPrevent: 'data-scroll-spy-prevent',
  mobile: 'data-scroll-spy-mobile',
  desktop: 'data-scroll-spy-desktop',
};

export const attributes$j = {
  index: 'data-index',
  tabIndex: 'tabindex',
  singleImage: 'data-slider-single-image',
  scrollSpyPrevent: 'data-scroll-spy-prevent',
};

export const attributes$i = {
  tabIndex: 'tabindex',
};

export const attributes$h = {
  expirationBehavior: 'data-expiration-behavior',
  leadingZero: 'data-leading-zero',
};

export const attributes$g = {
  storageNewsletterFormId: 'newsletter_form_id',
};

export const attributes$f = {
  tabIndex: 'tabindex',
};

export const attributes$e = {
  sliderId: 'data-slider-id',
  showImage: 'data-slider-show-image',
  tabIndex: 'tabindex',
};

export const attributes$d = {
  pointer: 'data-pointer',
  hotspot: 'data-hotspot',
  tabIndex: 'tabindex',
};


export const attributes$c = {
  parallaxAnimation: 'data-parallax',
  parallaxIntensity: 'data-parallax-intensity',
  singleElement: 'data-parallax-single',
};

export const attributes$b = {
  cookieName: 'data-cookie-name',
  targetReferrer: 'data-target-referrer',
  preventScrollLock: 'data-prevent-scroll-lock',
};

export const attributes$a = {
  logoSlide: 'data-logo-index',
  tabIndex: 'tabindex',
};

export const attributes$9 = {
  stickyEnabled: 'data-sticky-enabled',
};

export const attributes$8 = {
  dataImageWidth: 'data-image-width',
  dataImageHeight: 'data-image-height',
};

export const attributes$7 = {
  url: 'data-url',
};

export const attributes$6 = {
  mediaId: 'data-media-id',
  sectionId: 'data-section-id',
  thumbId: 'data-thumbnail-id',
  dataTallLayout: 'data-tall-layout',
  loaded: 'loaded',
  tabindex: 'tabindex',
};

export const attributes$5 = {
  href: 'href',
  mediaId: 'data-media-id',
  deferredMediaLoaded: 'data-deferred-media-loaded',
};


export const attributes$4 = {
  sectionId: 'data-section-id',
  productId: 'data-product-id',
  limit: 'data-limit',
  minimum: 'data-minimum',
  tabsLink: 'data-tabs-link',
};

export const attributes$3 = {
  slider: 'data-slider',
  slidePosition: 'data-slide-position',
  sectionId: 'data-section-id',
  tabIndex: 'tabindex',
};


export const attributes$2 = {
  style: 'data-style',
  currentStyle: 'data-current-style',
  tabIndex: 'tabindex',
  slidePosition: 'data-slide-position',
};

export const attributes$1 = {
  withGaps: 'data-sticky-with-gaps',
  singleText: 'data-sticky-single-text',
  index: 'data-index',
};

export const attributes$D = {
  ajaxinateId: 'data-ajaxinate-id',
};

export const attributes$J = {
  expanded: 'aria-expanded',
  controls: 'aria-controls',
  triggerMobile: 'data-collapsible-trigger-mobile',
  transitionOverride: 'data-collapsible-transition-override',
};

export const attributes$L = {
  srcset: 'srcset',
  loaded: 'data-loaded',
  deferredContainer: 'data-deferred-container',
};


export const attributes$A = {
  ariaExpanded: 'aria-expanded',
  ariaControls: 'aria-controls',
};

export const attributes$C = {
  filterActive: 'data-filter-active',
  preventScrollLock: 'data-prevent-scroll-lock',
  filtersDefaultState: 'data-filters-default-state',
  tabIndex: 'tabindex',
  ariaExpanded: 'aria-expanded',
  currentType: 'data-current-type',
};

export const attributes$I = {
  dataEnableSound: 'data-enable-sound',
  dataEnableBackground: 'data-enable-background',
  dataEnableAutoplay: 'data-enable-autoplay',
  dataEnableLoop: 'data-enable-loop',
  dataVideoId: 'data-video-id',
  dataVideoType: 'data-video-type',
};

export const attributes$H = {
  dataSectionId: 'data-section-id',
  dataEnableSound: 'data-enable-sound',
  dataHideOptions: 'data-hide-options',
  dataCheckPlayerVisibility: 'data-check-player-visibility',
  dataVideoId: 'data-video-id',
  dataVideoType: 'data-video-type',
};

export const attributes$y = {
  notificationPopup: 'data-notification-popup',
};


export const attributes$x = {
  productImageId: 'data-image-id',
  tallLayout: 'data-tall-layout',
  dataEnableHistoryState: 'data-enable-history-state',
  notificationPopup: 'data-notification-popup',
  swatchVariant: 'data-swatch-variant',
  disabled: 'disabled',
};

export const attributes$G = {
  loaded: 'loaded',
  sectionId: 'data-section-id',
  dataAutoplayVideo: 'data-autoplay-video',
  mediaId: 'data-media-id',
};

export const attributes$t = {
  loaded: 'data-loaded',
  handle: 'data-handle',
  variantId: 'data-variant-id',
  shopTheLookQuickView: 'data-shop-the-look-quick-view',
  hotspot: 'data-hotspot',
  quickButtonInit: 'data-initialized',
};

export const attributes$z = {
  optionPosition: 'data-option-position',
  selectOptionValue: 'data-value',
};

export const attributes$B = {
  tabsLink: 'data-tabs-link',
  tab: 'data-tab',
  tabRef: 'data-tab-ref',
  tabStartIndex: 'data-start-index',
  searchPerformed: 'data-search-performed',
  type: 'data-type',
  currentType: 'data-current-type',
  allTypes: 'data-all-types',
  currentPage: 'data-current-page',
  ajaxinateId: 'data-ajaxinate-id',
};

export const attributes$F = {
  aos: 'data-aos',
  tooltip: 'data-tooltip',
  tooltipContainer: 'data-tooltip-container',
  tooltipStopMouseEnter: 'data-tooltip-stop-mouseenter',
};

export const attributes$M = {
  transparent: 'data-transparent',
};

export const attributes = {
  sectionId: 'data-section-id',
};